import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
var _excluded = ["prefixCls", "className", "size", "type", "steps", "showInfo", "strokeColor"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import * as React from 'react';
import classNames from 'classnames';
import omit from 'rc-util/lib/omit';
import CloseOutlined from '@ant-design/icons/CloseOutlined';
import CheckOutlined from '@ant-design/icons/CheckOutlined';
import CheckCircleFilled from '@ant-design/icons/CheckCircleFilled';
import CloseCircleFilled from '@ant-design/icons/CloseCircleFilled';
import { tuple } from '../_utils/type';
import devWarning from '../_utils/devWarning';
import { Line } from './Line';
import { Circle } from './Circle';
import { Steps } from './Steps';
import { validProgress, getSuccessPercent } from './utils';
import { ConfigContext } from '../../config/context/config';
var ProgressTypes = tuple('line', 'circle', 'dashboard');
var ProgressStatuses = tuple('normal', 'exception', 'active', 'success');
export var Progress = /*#__PURE__*/function (_React$Component) {
  _inherits(Progress, _React$Component);
  var _super = _createSuper(Progress);
  function Progress() {
    var _this;
    _classCallCheck(this, Progress);
    _this = _super.apply(this, arguments);
    _this.renderProgress = function (_ref) {
      var _classNames;
      var getPrefixCls = _ref.getPrefixCls;
      var _assertThisInitialize = _assertThisInitialized(_this),
        props = _assertThisInitialize.props;
      var customizePrefixCls = props.prefixCls,
        className = props.className,
        size = props.size,
        type = props.type,
        steps = props.steps,
        showInfo = props.showInfo,
        strokeColor = props.strokeColor,
        restProps = _objectWithoutProperties(props, _excluded);
      var prefixCls = getPrefixCls('progress', customizePrefixCls);
      var progressStatus = _this.getProgressStatus();
      var progressInfo = _this.renderProcessInfo(prefixCls, progressStatus);
      devWarning(!('successPercent' in props), 'Progress', '`successPercent` is deprecated. Please use `success.percent` instead.');
      var progress;
      if (type === 'line') {
        progress = steps ? React.createElement(Steps, _objectSpread(_objectSpread({}, _this.props), {}, {
          strokeColor: typeof strokeColor === 'string' ? strokeColor : undefined,
          prefixCls: prefixCls,
          steps: steps
        }), progressInfo) : React.createElement(Line, _objectSpread(_objectSpread({}, _this.props), {}, {
          prefixCls: prefixCls
        }), progressInfo);
      } else if (type === 'circle' || type === 'dashboard') {
        progress = React.createElement(Circle, _objectSpread(_objectSpread({}, _this.props), {}, {
          prefixCls: prefixCls,
          progressStatus: progressStatus
        }), progressInfo);
      }
      var classString = classNames(prefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-").concat(type === 'dashboard' && 'circle' || steps && 'steps' || type), true), _defineProperty(_classNames, "".concat(prefixCls, "-status-").concat(progressStatus), true), _defineProperty(_classNames, "".concat(prefixCls, "-show-info"), showInfo), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(size), size), _classNames), className);
      return React.createElement("div", _objectSpread(_objectSpread({}, omit(restProps, ['status', 'format', 'trailColor', 'strokeWidth', 'width', 'gapDegree', 'gapPosition', 'strokeLinecap', 'percent', 'success', 'successPercent'])), {}, {
        className: classString
      }), progress);
    };
    return _this;
  }
  _createClass(Progress, [{
    key: "getPercentNumber",
    value: function getPercentNumber() {
      var _this$props$percent = this.props.percent,
        percent = _this$props$percent === void 0 ? 0 : _this$props$percent;
      var successPercent = getSuccessPercent(this.props);
      return parseInt(successPercent !== undefined ? successPercent.toString() : percent.toString(), 10);
    }
  }, {
    key: "getProgressStatus",
    value: function getProgressStatus() {
      var status = this.props.status;
      if (ProgressStatuses.indexOf(status) < 0 && this.getPercentNumber() >= 100) {
        return 'success';
      }
      return status || 'normal';
    }
  }, {
    key: "renderProcessInfo",
    value: function renderProcessInfo(prefixCls, progressStatus) {
      var _this$props = this.props,
        showInfo = _this$props.showInfo,
        format = _this$props.format,
        type = _this$props.type,
        percent = _this$props.percent;
      var successPercent = getSuccessPercent(this.props);
      if (!showInfo) {
        return null;
      }
      var text;
      var textFormatter = format || function (percentNumber) {
        return "".concat(percentNumber, "%");
      };
      var isLineType = type === 'line';
      if (format || progressStatus !== 'exception' && progressStatus !== 'success') {
        text = textFormatter(validProgress(percent), validProgress(successPercent));
      } else if (progressStatus === 'exception') {
        text = isLineType ? React.createElement(CloseCircleFilled, null) : React.createElement(CloseOutlined, null);
      } else if (progressStatus === 'success') {
        text = isLineType ? React.createElement(CheckCircleFilled, null) : React.createElement(CheckOutlined, null);
      }
      return React.createElement("span", {
        className: "".concat(prefixCls, "-text"),
        title: typeof text === 'string' ? text : undefined
      }, text);
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(ConfigContext.Consumer, null, this.renderProgress);
    }
  }]);
  return Progress;
}(React.Component);
Progress.defaultProps = {
  type: 'line',
  percent: 0,
  showInfo: true,
  trailColor: null,
  size: 'default',
  gapDegree: undefined,
  strokeLinecap: 'round'
};